import React from "react";
import { Navigate, useParams } from "react-router-dom";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import ChildAppMount from "../../shellHost/ChildAppMount";

// /apps/:slug/* -- the page every child app is mounted in.
const ChildAppPage: React.FC = () => {
  const { slug } = useParams();
  if (!slug) return <Navigate to="/landing" replace />;

  return (
    <div className="flex flex-col min-h-screen bg-[#F7F7FF]">
      <div className="flex-grow">
        <Header />
        <main>
          <ChildAppMount key={slug} slug={slug} />
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default ChildAppPage;
